import { style, StyleRule } from "@vanilla-extract/css";
import { vars } from "../../styles";

export const tabsStyles = style({
  display: "flex",
  color: vars.colors.onSurfaceVariant,
  selectors: {
    '&[data-orientation="horizontal"]': {
      flexDirection: "column",
    },
  },
});

export const tabListStyles = style({
  display: "flex",
  justifyContent: "center",
  gap: vars.space.m,
});

const tabHighlight: StyleRule = {
  content: '""',
  position: "absolute",
  display: "block",
  left: 0,
  bottom: 0,
  height: 4,
  width: "100%",
  backgroundColor: vars.colors.primary,
  borderStartStartRadius: 2,
  borderStartEndRadius: 2,
};

export const tabStyles = style({
  position: "relative",
  cursor: "pointer",
  padding: `${vars.space.xs} 0`,
  selectors: {
    "&[data-selected]": {
      color: vars.colors.primary,
      fontFamily: vars.fonts.bold,
    },
    "&[data-hovered], &[data-focused]": {
      color: vars.colors.primary,
    },
    "&[data-hovered]:not([data-selected])::after, &[data-focused]:not([data-selected])::after":
      tabHighlight,
    "&[data-selected]::after": tabHighlight,
    "&[data-focused]": { outline: "none" },
    "&[data-focus-visible]": {
      outline: vars.borders.outline,
    },
  },
});

export const tabPanelStyles = style({
  paddingTop: vars.space.m,
  paddingBottom: vars.space.m,
  selectors: {
    "&[data-focus-visible]": {
      outline: vars.borders.outline,
    },
  },
});
